export enum PRODUCTIVITY_RANGE {
    SIX_MO='last6mo',
    YTD='YTD',
    LAST_YEAR='lastYear',
    LAST_2_YEARS='last2Year'
}